import {Grid} from "@mui/material";
import {useState} from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {SmallGreyButton} from "../../../../misc/SmallGreyButton";

export function SubmittalMaker(props: {
    title?: string;
    icon?: any;
    creator: (props: ({onDone: () => void})) => any;
}) {
    const [show, setShow] = useState(false);
    const Creator = props.creator;

    return (
        <Grid item>
            <SmallGreyButton onClick={() => setShow(true)} startIcon={props.icon || <AddCircleIcon />}>
                {props.title || "Create Submittal"}
            </SmallGreyButton>
            {show && <Creator onDone={() => setShow(false)} />}
        </Grid>
    )
}